import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Note, Page } from "../../../helbest";
import { _set_store, set_checkout_id, set_transaction_id } from "../../../store/actions/login_actions";
import { _Cart_Clean } from "../../../store/actions/cart_actions";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { Select } from "antd";

// icons
import { ReactComponent as BottomArrow } from "../../../assets/svg/bottom-arrow.svg";
import Button from "../../components/ui/Button";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
import { useTranslation } from "react-i18next";
import { BaseChannel } from "../../../base/env";
import { calculator } from "../../../base/utils";
import { API } from "../../../request/api";

const { Option } = Select;

export const ChangeCountry = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const Login = useSelector((state) => state.Login);

    const navigate = useLangNavigate();
    const [loading, setLoading] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [selected_country, set_selected_country] = useState(Login.country_id || null);

    const COUNTRY_LIST = [
        {
            id: 1150,
            name: 'Canada'
        },
        {
            id: 1,
            name: 'Oman'
        },
        {
            id: 1289,
            name: 'Saudi Arabia'
        }
    ]

    const getCountries = () => {
        setLoading(true);
        API.get
            .countries()
            .then((response) => {
                if (response.success) {
                    setCountryList(response.data);
                } else {
                    Note.error(response.message);
                }
            })
            .catch((error) => {
                console.error('Failed to load countries:', error);
                setCountryList(COUNTRY_LIST);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getCountries();
    }, []);





    const select_country = (value) => {
        set_selected_country(value);
    };


    const set_store = () => {

        if (!selected_country) {
            Note.error(t('location.messages.empty'));
            return;
        }

        dispatch(_Cart_Clean());
        dispatch(set_checkout_id({ checkout_id: "" }));
        dispatch(set_transaction_id(""));

        const country = countryList.find((item) => item.id === selected_country);

        if (country.name === 'Canada') {
            dispatch(
                _set_store(
                    country.id,
                    'Canada',
                    'canada'
                )
            );
        } if (country.name === 'Oman') {
            dispatch(_set_store(country.id, 'Oman', BaseChannel));
        }
        if (country.name == 'Saudi Arabia') {
            dispatch(_set_store(country.id, 'Saudi Arabia', 'saudi-channel'));

        }

        calculator();
        navigate('/');
    };

    return (
        <Page
            className="page-change-store-location"
            back={true}
            customHeader={<HeaderBack title={t('location.title')} />}
            address="/"
            logo>
            <div className="desktop-mode change-store-location-container">
                <p className="flex justify-between items-center mb-4">{t('location.desc')}</p>
                <Select
                    dir="ltr"
                    value={loading ? null : selected_country}
                    className="change-store-location-select"
                    popupClassName="change-store-dropdown"
                    placeholder={t('common.country')}
                    disabled={loading}
                    suffixIcon={<BottomArrow width={10} height={10} />}
                    onChange={(value) => select_country(value)}
                    placement="bottomRight">
                    {countryList.map((country, pdx) => {
                        return (
                            <Option key={pdx} value={country.id}>
                                {country.name}
                            </Option>
                        );
                    })}
                </Select>

            </div>
            <div className="page-fixed-footer-container">
                <Button
                    onClick={set_store}
                    size="large"
                    type="primary"
                    style={{
                        width: '100%'
                    }}>
                    {t('location.button')}
                </Button>
            </div>
        </Page>
    );
};

export default ChangeCountry;
